<template>
    <div class="tab-bar-content">
        <a-tabs
            v-model:activeKey="activeTab"
            @change="handleTabClick"
            hideAdd
            type="editable-card"
        >
            <a-tab-pane
                v-for="tab in tabs"
                :key="tab.path"
                :tab="tab.meta.title"
            >
                <template #closeIcon v-if="tab.name!='Home'">
                    <CloseOutlined @click.stop="handleTabClose(tab.path)" />
                </template>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script setup>
import {CloseOutlined} from '@ant-design/icons-vue'
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { initTab,tabs, activeTab, closeTab, setActiveTab } from '../../utils/tabStore';

const router = useRouter();

const handleTabClick = (path) => {
    console.log(path)
    setActiveTab(path);
    router.push(path);
};

const handleTabClose = (tabName) => {
    console.log(tabName)
    if(tabs.value.length===1) return
    closeTab(tabName);
};
onMounted(()=>{
    initTab()
})
</script>

<style lang="less" scoped>
// .tabbar {
//     position: fixed;
//     top: 64px;
//     left: 200px;
//     right: 0;
//     background-color: white;
//     z-index: 98;
//     border-bottom: 1px solid #e8e8e8;
// }
</style>../../utils/tabStore